import classnames from 'classnames';
import React from 'react';
import { useSwipeable } from 'react-swipeable';
import useCloseMenu from '~/hooks/use-close-menu';
import { useServicesContext } from '~/providers/services-context';
import type INavData from '../../../interfaces/config/nav';
import useStore from '../../../store';
import Icon from '~/components/icon';
import Title from '../../title';
import styles from '../style/all-sports-menu.module.css';
import FeaturedMenu from './featured-menu';
import SportsList from './sports-list';
import { Header } from '../../title/title';

interface IProps {
  navData: INavData;
}

function AllSportsMenu({ navData }: IProps): JSX.Element {
  const { labelActions } = useServicesContext();

  const [fullHeight, setFullHeight] = React.useState(false);

  const [allSportsOpenBottom, setShowAllSportsBottom] = useStore(
    ({ showAllSportsBottom, setShowAllSportsBottom }) => [
    showAllSportsBottom,
    setShowAllSportsBottom]

  );

  const openCloseSportsMenu = (): void => {
    setShowAllSportsBottom(!allSportsOpenBottom);
  };

  React.useEffect(() => {
    setFullHeight(false);
  }, [allSportsOpenBottom]);

  const handleSwipeUp = (): void => {
    if (fullHeight) {
      return;
    }
    setFullHeight(true);
  };

  const handleSwipeDown = (): void => {
    if (fullHeight) {
      setFullHeight(false);
    } else {
      openCloseSportsMenu();
    }
  };

  const handlers = useSwipeable({
    onSwipedUp: () => handleSwipeUp(),
    onSwipedDown: () => handleSwipeDown(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const isMenuOpen = allSportsOpenBottom;

  const hideAllSports = (): void => setShowAllSportsBottom(false);

  // Handle menu close on click or escape
  useCloseMenu(wrapperRef, isMenuOpen, hideAllSports);

  return (
    <div
      ref={wrapperRef}
      data-testid="all-sports-menu"
      className={classnames(
        styles.allSportsMenu,
        allSportsOpenBottom ? styles.open : '',
        fullHeight ? styles.fullHeight : ''
      )}>

			<div className={styles.content}>
				<div className={styles.header} {...handlers}>
					<Title tag={Header.SPAN} title={labelActions.get('SPORTS_ODDS')} testId="all-sports-heading" />
					<button aria-label="Close menu" onClick={openCloseSportsMenu}>
						<Icon icon="Close" />
					</button>
				</div>
				<FeaturedMenu navData={navData} />
				<SportsList navData={navData} />
			</div>
		</div>);

}

export default AllSportsMenu;